import * as Api from "@api";
import React from "react";
import {Container} from "../Container";
import {Margin} from "../Layout";
import {ImageCard} from "./ImageCard";
import {getImageCardStdProps, ImageCardStdProps, ImageCardStdSpecificProps, Typography} from '@/components';

type ImageCardListItemProps =
    {
        key?: string;
        patent?: string
    }
    & (
        {
            node: React.ReactNode;
        }
        |
        {
            stdProps: ImageCardStdSpecificProps & { imageSuffix?: string };
        }
        |
        {
            props: React.ComponentProps<typeof ImageCard>;
        }
    );

interface ImageCardListProps
{
    containerProps?: React.ComponentProps<typeof Container>;
    cards: ImageCardListItemProps[];
    imageDirectory: string;
    itemHeadingMarginBottom?: Margin;
    itemHeadingTypography?: Typography;
    keyPrefix: string;
    pageContent: Record<string, Api.ContentItem>;
}

export const ImageCardList = ({ cards, containerProps, imageDirectory, itemHeadingMarginBottom, itemHeadingTypography, keyPrefix, pageContent }: ImageCardListProps): React.FunctionComponentElement<ImageCardListProps> =>
{
    return (
        <Container {...containerProps}>
            {
                cards.map(item =>
                {
                    if ("node" in item)
                    {
                        return item.node;
                    }
                    else if ("props" in item)
                    {
                        return <ImageCard {...item.props} key={item.key} />;
                    }
                    else if ("stdProps" in item)
                    {
                        const stdProps: ImageCardStdProps = {
                            ...item.stdProps,
                            headingMarginBottom: item.stdProps.headingMarginBottom ?? itemHeadingMarginBottom,
                            headingTypography: item.stdProps.headingTypography ?? itemHeadingTypography,
                            imageDirectory,
                            imageName: item.stdProps.imageName ?? `${keyPrefix}.${item.stdProps.imageSuffix ?? item.key}`,
                            keyBase: `${keyPrefix}${!!item.key ? `.${item.key}` : ``}`,
                            pageContent
                        }
                        return <ImageCard {...getImageCardStdProps(stdProps)} className={item.stdProps.className} key={item.key} />;
                    }
                    return null;
                })
            }
        </Container>
    );
};